module.exports = __webpack_public_path__ + "static/media/pic5.568b81dc.jpg";